import { useState, FC, useEffect, useRef } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import { type TooltipProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

// import style from './OverflowedTextTooltip.module.scss?module';
import clsx from 'clsx';

interface OverflowedTextTooltipProps {
  text: string;
  className?: string;
  textClassName?: string;
  textClassNameIfOverflowed?: string;
  placement?: TooltipProps['placement'];
}

const OverflowedTextTooltip: FC<OverflowedTextTooltipProps> = ({
  text,
  className = '',
  textClassName = '',
  textClassNameIfOverflowed = '',
  placement = 'top',
}) => {
  const [isOverflowed, setIsOverflow] = useState(false);
  const elementRef = useRef<HTMLHeadingElement>(null);

  const checkOverflow = () => {
    if (elementRef.current) {
      setIsOverflow(
        elementRef.current.scrollWidth > elementRef.current.clientWidth
      );
    }
  };

  useEffect(() => {
    checkOverflow();

    const handleResize = () => checkOverflow();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [text]);

  const content = (
    <div
      className={clsx(
        'd-flex',
        className,
        // isOverflowed ? style.overflowedText : '',
        isOverflowed ? textClassNameIfOverflowed : textClassName
      )}
      style={{
        whiteSpace: 'nowrap',
        cursor: isOverflowed ? 'help' : 'default',
        alignItems: 'center',
      }}
    >
      <div
        ref={elementRef}
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          margin: 0,
          position: 'relative',
        }}
      >
        {text}
      </div>
      {isOverflowed && <FontAwesomeIcon icon={faCircleInfo} />}
    </div>
  );

  return isOverflowed ? (
    <Tooltip placement={placement} title={text}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default OverflowedTextTooltip;
